const screenDiameterCalculationInCm = (width, height) => {
  const widthInCm = width * 0.0264583333;
  const heightInCm = height * 0.0264583333;

  return Math.sqrt((widthInCm ** 2) + (heightInCm ** 2));
};

export default screenDiameterCalculationInCm;
